function fadeIn(element, time = 10, opacity = 1) {
  // Fallback for older iPhones not supporting Web animations API (https://caniuse.com/web-animation)
  if (!element.animate) {
    element.style.opacity = opacity;
    return;
  }

  return element.animate(
    [
      {
        opacity: 0
      },
      {
        opacity
      }
    ],
    {
      duration: time,
      fill: 'forwards',
      easing: 'ease-out'
    }
  );
}
function fadeOut(element, time = 1000, opacity = 0) {
  // Fallback for older iPhones not supporting Web animations API (https://caniuse.com/web-animation)
  if (!element.animate) {
    element.style.opacity = opacity;
    return;
  }

  return element.animate(
    [
      {
        opacity: 1
      },
      {
        opacity
      }
    ],
    {
      duration: time,
      fill: 'forwards',
      easing: 'ease-out'
    }
  );
}
// @todo Following methods removed because they are not used and don't work with older iPhones, due to missing Web animations API (https://caniuse.com/web-animation)
// function fadeInDown(element, time = 500) {
//   // @todo This won't work for older iPhones not supporting Web animations API (https://caniuse.com/web-animation)
//   element.animate(
//     [
//       {
//         opacity: 0,
//         transform: 'translateY( -100% )'
//       },
//       {
//         opacity: 1,
//         transform: 'translateY( 0% )'
//       }
//     ],
//     {
//       duration: time,
//       fill: 'forwards',
//       easing: 'ease-out'
//     }
//   );
// }
// async function sequentialFade(
//   elements = [],
//   opacity = 0,
//   duration = 300,
//   delay = 100
// ) {
//   // @todo This won't work for older iPhones not supporting Web animations API (https://caniuse.com/web-animation)
//   Array.from(elements).forEach((el, index) => {
//     el.animate(
//       { opacity },
//       { delay: index * delay, duration, fill: 'forwards' }
//     );
//   });
//   const time = (elements.length - 2) * delay + duration;
//   await new Promise((resolve) => {
//     setTimeout(() => {
//       resolve();
//     }, time);
//   });
// }
// function shrinkOut(element, time = 1000, scale = 0) {
//   // @todo This won't work for older iPhones not supporting Web animations API (https://caniuse.com/web-animation)
//   return element.animate(
//     [
//       {
//         transform: 'scale(1)'
//       },
//       {
//         transform: `scale(${scale})`
//       }
//     ],
//     {
//       duration: time,
//       fill: 'forwards',
//       easing: 'ease-in-out'
//     }
//   );
// }
// function growIn(element, time = 1000, scale = 1) {
//   // @todo This won't work for older iPhones not supporting Web animations API (https://caniuse.com/web-animation)
//   return element.animate(
//     [
//       {
//         transform: 'scale(0)'
//       },
//       {
//         transform: `scale(${scale})`
//       }
//     ],
//     {
//       duration: time,
//       fill: 'forwards',
//       easing: 'ease-in-out'
//     }
//   );
// }
// function brandFontColour(element, colour = '00B2A9') {
//   // @todo This won't work for older iPhones not supporting Web animations API (https://caniuse.com/web-animation)
//   return element.animate(
//     [
//       {
//         color: `#${colour}`
//       }
//     ],
//     {
//       duration: 100,
//       fill: 'forwards'
//     }
//   );
// }
// function addBackgroundColour(element, colour = '00B2A9') {
//   // @todo This won't work for older iPhones not supporting Web animations API (https://caniuse.com/web-animation)
//   return element.animate(
//     [
//       {
//         backgroundColor: `#${colour}`
//       }
//     ],
//     {
//       duration: 100,
//       fill: 'forwards'
//     }
//   );
// }
// function colourSwipe(element, colour = '00B2A9', direction = '+') {
//   // @todo This won't work for older iPhones not supporting Web animations API (https://caniuse.com/web-animation)
//   return (
//     element.animate(
//       [
//         {
//           boxShadow: `inset ${direction}200vw 0 0 0 #${colour}`
//         }
//       ],
//       {
//         duration: 500,
//         easing: 'linear',
//         pseudoElement: '::after'
//       }
//     ) &&
//     element.animate(
//       [
//         {
//           backgroundColor: `#${colour}`
//         }
//       ],
//       {
//         duration: 400,
//         delay: 100,
//         fill: 'forwards'
//       }
//     )
//   );
// }

const api = {
  fadeIn,
  fadeOut
  // @todo Following methods removed because they are not used and don't work with older iPhones, due to missing Web animations API (https://caniuse.com/web-animation)
  // fadeInDown,
  // sequentialFade,
  // shrinkOut,
  // growIn,
  // brandFontColour,
  // addBackgroundColour,
  // colourSwipe
};

export default api;
